import React from "react";
import { Button } from "@material-ui/core";
import bazarpng from "../../../ebusHomePics/Assets/bazar-2.png";
import downloadpng from "../../../ebusHomePics/Assets/download.png";
import phoneImg from "../../../ebusHomePics/Assets/mobile-2.png";
import * as Scroll from "react-scroll";

const MobileIntro = (props) => {
  const scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop()
  }, []);

  return (
    <div
      className="d-flex flex-wrap container"
      style={{ fontFamily: "sans", paddingBlock: "5rem 3rem" }}
    >
      <div className="col-12 col-md-6">
        <div
          className="bg-white shadow-sm d-flex flex-column py-9 px-12"
          style={{ borderRadius: "13px", gap: "17px" }}
        >
          <h4
            style={{
              borderBottom: "2.3px solid #6dd06d",
              whiteSpace: "nowrap",
            }}
            className="col-6 pb-5 mt-3 mb-4"
          >
            دانلود نسخه اندروید
          </h4>
          <Button
            fullWidth
            style={{ border: "1px solid #6dd06d", borderRadius: "14px" }}
          >
            <div
              className="d-flex mr-auto p-3"
              style={{ alignItems: "flex-end", gap: "10px" }}
            >
              <img src={bazarpng} style={{ height: "2rem" }} />
              <h5 className="my-auto" style={{ lineHeight: "20px" }}>
                {" "}
                دانلود از کافه بازار
              </h5>
            </div>
          </Button>
          <Button
            fullWidth
            style={{ border: "1px solid #6dd06d", borderRadius: "14px" }}
          >
            <div
              className="d-flex mr-auto p-3"
              style={{ alignItems: "flex-end", gap: "10px" }}
            >
              <img src={downloadpng} style={{ height: "2rem" }} />
              <h5 className="my-auto"> دانلود مستقیم</h5>
            </div>
          </Button>
          <h4
            style={{
              borderBottom: "2.3px solid #6dd06d",
              whiteSpace: "nowrap",
            }}
            className="col-6 pb-5 mt-15"
          >
            دانلود نسخه IOS
          </h4>
          <h6 style={{ lineHeight: "20px" }}>
            نسخه IOS به زودی اضافه خواهد شد
          </h6>
        </div>
      </div>
      <div className="d-none d-md-flex col-6">
        <img
          src={phoneImg}
          style={{ objectFit: "contain", height: "34rem" }}
          className="w-100"
        />
      </div>
    </div>
  );
};

export default MobileIntro;
